<template>
  <DropdownSelector
    ref="dropdownSelector"
    v-model:open="store.showOptionsModal"
    :heading="heading"
    :active="activeOption"
    @option-click="handleCustomClick"
  >
    <template #selected-option="{ option }">
      <DropdownOptionItem :option="option" :is-in-stock="option.isInStock" />
    </template>

    <template #options="{ onOptionClick }">
      <DropdownOptionsList
        class="overflow-hidden rounded-b-lg"
        :options="options"
        :active-option-id="activeOptionId"
        @click="onOptionClick"
      />
    </template>
  </DropdownSelector>
</template>

<script setup>
import { computed, onMounted, watch } from 'vue';

import DropdownSelector from '@/shared/components/UI/DropdownSelector.vue';
import { useTranslations } from '@/shared/composables/useTranslations.ts';
import { useViewport } from '@/shared/composables/useViewport';
import { useProductOptionsStore } from '@/shared/pinia/modules/product-options';

import DropdownOptionItem from './DropdownOptionItem.vue';
import DropdownOptionsList from './DropdownOptionsList.vue';

const { t } = useTranslations();
const store = useProductOptionsStore();

const activeOption = computed(() => store.activeOption);
const activeOptionId = computed(() => store.activeOption?.id);

const heading = computed(
  () => `${t('product.options.text_option')} ${store.kind.name}`
);
const options = computed(() => store.options);

const { isMobile } = useViewport();

watch(isMobile, (newVal) => {
  if (!newVal) {
    store.showOptionsModal = false;
  }
});

const handleCustomClick = (option) => {
  store.updateActiveOption(option);
};

onMounted(() => {
  if (activeOption.value) {
    store.updateActiveOption(activeOption.value);
  }
});
</script>
